<template>
	<div id="app" :class="{padmobile: isMobile}">
		<router-view name="header"></router-view>
		<main>
			<fade-transition origin="center" mode="out-in" :duration="250">
				<router-view />
			</fade-transition>
		</main>
		<router-view name="footer"></router-view>
	</div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
	components: {
		FadeTransition,
	},
  data() {
		return {
      isMobile: this.$mobile()
		}
	},
};
</script>
<style>
  .padmobile {
    padding-top: 46px;
  }
</style>
